import { HttpClient } from '@angular/common/http'
import { Component, NgZone } from '@angular/core'
import { AuthService } from 'app/_services'
import { LoaderService } from 'app/_services/loader.service'
import { environment } from 'environments/environment'
declare var $: any

@Component({
  selector: 'assetMasterDetails',
  templateUrl: './assetMasterDetails.component.html',
})
export class AssetMasterDetailsReportComponent {
  public ItemName: any
  public SerialImei: any
  public AssetDescription: any
  public assetCategory: any
  public assetCategoryModal: any
  showLoader: boolean

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private loaderService: LoaderService,
    private _ngZone: NgZone,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
  }

  ngOnInit() {
    this.showLoader = false
    this.assetCategory = [
      { id: 1, name: 'Laptop' },
      { id: 2, name: 'Mouse' },
      { id: 3, name: 'Printer' },
    ]
  }

  openAssetForm() {
    this.ItemName = ''
    this.SerialImei = ''
    this.AssetDescription = ''
    this.assetCategoryModal = ''
    $('#addAssetItem').modal('show')
  }

  saveAssetForm() {
    var assetJsonData = {
      ItemName: this.ItemName,
      SerialImei: this.SerialImei,
      AssetDescription: this.AssetDescription,
      assetCategory: this.assetCategoryModal,
    }

    this.http
      .post(environment.apiUrl + 'reports/saveAssetData', assetJsonData)
      .subscribe(
        (data) => {
          console.log(data)
        },
        (err) => {
          console.log('255', err)
        },
      )
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/itAsset/assetMasterDetails.components.ts